import { useTranslation } from 'react-i18next';
import { cn, getValuableVariables } from '@anytag/shared-utils';
import { SectionWithHeader } from '@anytag/shared-molecules';
import { useYoutubeCompareTagRankingQuery, YoutubeCompareTagRanking } from '@anytag/graphql';
import { HAS_NO_SELECTED_ACCOUNTS } from '@anytag/shared-constants';
import { NoDataContentWrapper, RenderDataWithFallback } from '@anytag/shared-atoms';
import { AnalyticsCompareYoutubeAccountsProps } from '../AnalyticsCompareYoutubeAccounts';
import { useAnalyticsProfileSearch } from '../../../hooks';
import { Template } from './Template';

export interface AnalyticsCompareYoutubeTagsRankingProps
  extends Pick<
    AnalyticsCompareYoutubeAccountsProps,
    'accounts' | 'mainAccountId' | 'hiddenAccountIds' | 'hasFreePlan'
  > {
  tagsRankingMock: YoutubeCompareTagRanking;
}

export const AnalyticsCompareYoutubeTagsRanking = ({
  accounts,
  mainAccountId,
  hiddenAccountIds,
  hasFreePlan,
  tagsRankingMock
}: AnalyticsCompareYoutubeTagsRankingProps) => {
  const { t } = useTranslation();
  const { filter } = useAnalyticsProfileSearch();
  const { data, loading } = useYoutubeCompareTagRankingQuery({
    variables: getValuableVariables({
      mainAccountId,
      endDate: filter.endDate,
      startDate: filter.startDate
    }),
    skip: hasFreePlan
  });

  const compareTagsData = hasFreePlan ? tagsRankingMock : data?.youtubeCompareTagRanking;
  const comparableAccounts = accounts.filter((account) => !hiddenAccountIds?.includes(account.id));
  const hasNoData = !comparableAccounts.length || !compareTagsData;

  return (
    <div className="mt-6">
      <RenderDataWithFallback loading={loading}>
        <SectionWithHeader title={t('Tag Ranking')} prefixIcon={{ icon: 'user-two-tones' }}>
          <NoDataContentWrapper
            dataNotAvailable={hasNoData}
            wrapperText={HAS_NO_SELECTED_ACCOUNTS}
            className={cn({ 'min-h-0': !hasNoData })}
          >
            {compareTagsData ? <Template data={compareTagsData} comparableAccounts={comparableAccounts} /> : null}
          </NoDataContentWrapper>
        </SectionWithHeader>
      </RenderDataWithFallback>
    </div>
  );
};
